import styled from "styled-components";

export const Content = styled.div``;

export const SpaceY: any = styled.div`
  height: ${(props: any) => props.space}px !important;
`;

export const SpaceX: any = styled.div`
  width: ${(props: any) => props.space}px !important;
`;

export const Header = styled.div`
  display: flex;
  margin: 0 0 16px;
  padding: 16px 24px;
  background-color: #0000000a;
  border-radius: 8px;

  .col-1 {
    flex: 3;
  }
  .col-2 {
    flex: 1.5;
  }
  .col-3 {
    flex: 0.8;
  }
  .col-4 {
    flex: 1;
  }
`;

export const TextHeader = styled.p`
  font-family: Inter;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  text-align: left;
`;

export const BodyItems = styled.div`
  display: flex;

  .col-1 {
    flex: 3;
  }
  .col-2 {
    flex: 1.5;
  }
  .col-3 {
    flex: 0.8;
  }
  .col-4 {
    flex: 1;
  }
`;

export const Body = styled.div`
  padding: 16px 24px;
  border-radius: 8px;
  border: 1px solid #ececec;
`;

export const TableImage = styled.img`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin-right: 12px;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TextProduct = styled.p`
  font-family: Inter;
  font-size: 16px;
  font-weight: 400;
  line-height: 19.36px;
  letter-spacing: -0.01em;
  text-align: left;
`;

export const TextBlocoUnidade = styled.p`
  font-family: Inter;
  font-size: 13px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: -0.01em;
  text-align: left;
`;

export const TextCOT = styled.p`
  font-family: Inter;
  font-size: 13px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: -0.01em;
  text-align: left;
  color: #2d5bff;
`;

export const TextFicha = styled.p`
  font-family: Inter;
  font-size: 13px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: -0.01em;
  text-align: left;
  color: #333333;
`;

export const TextEtapa = styled.p`
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  line-height: 19.36px;
  letter-spacing: -0.01em;
  text-align: left;
  color: #333333;
`;

export const PositionContainer = styled.div`
  position: relative;
  display: inline-block; /* Necessário para que o posicionamento relativo funcione corretamente */
`;

export const TextSimulation: any = styled.p`
  font-family: Inter;
  font-size: 12px;
  font-weight: 500;
  line-height: 15.6px;
  text-align: center;
  background-color: ${(props: any) => props.color};
  color: #ffffff;
  padding: 4px 8px;
  display: inline-block;
  border-radius: 16px;
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 32px;
  white-space: nowrap;
  width: auto;
  max-width: fit-content;
`;

export const Divider = styled.div`
  height: 1px;
  background-color: #ececec;
  width: 100%;
`;

export const BadgePropostaManual = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 16px;
  background-color: #e8f5e9;
  border: 1px solid #4caf50;
  white-space: nowrap;
  width: fit-content;
`;

export const TextPropostaManual = styled.span`
  font-family: Inter;
  font-size: 12px;
  font-weight: 600;
  line-height: 15.6px;
  color: #2e7d32;
`;

export const LeadInfoRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: center;
`;

export const LeadInfoItemCompact = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background-color: #f8f9fa;
  border-radius: 6px;
  border: 1px solid #e9ecef;
  min-width: 140px;
`;

export const LeadInfoText = styled.div`
  display: flex;
  flex-direction: column;
`;

export const LeadInfoLabelSmall = styled.span`
  font-family: Inter;
  font-size: 10px;
  font-weight: 500;
  line-height: 12px;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.3px;
`;

export const LeadInfoValueSmall = styled.span`
  font-family: Inter;
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
  color: #333333;
  margin-top: 1px;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
